import { useContext, useMemo } from 'react'

import { BoxProps, Grid } from '@mantine/core'

import { CtaBannerContext } from '../../context'
import { configGrid } from '../../helpers'
import { MultipleBanner } from '../../index.types'
import { Item } from '../Item'

type Props = {
  banners: MultipleBanner['listing'][number]['banners']
  keepGridCol?: boolean
} & BoxProps

export const GridLayout = ({ banners, keepGridCol }: Props) => {
  const { data } = useContext(CtaBannerContext)
  const { layout } = (data || {}) as MultipleBanner
  const configObj = useMemo(() => configGrid(banners.length, layout), [banners])
  return (
    <Grid
      gutterSm={configObj.smGap}
      gutterMd={configObj.gap}
      grow={keepGridCol ? false : configObj.grow}
    >
      {banners.map((banner, index) => (
        <Grid.Col key={String(index)} md={configObj.span}>
          <Item
            key={String(index)}
            data={banner}
            layout={layout}
            infoLayout={
              banners.length <= 2 && !keepGridCol ? 'horizon' : 'vertical'
            }
            radius={banners.length > 2 ? 16 : 24}
            ratio={configObj.ratio}
          />
        </Grid.Col>
      ))}
    </Grid>
  )
}
